import { styled } from "@material-ui/core";
import { Column, div, Flex, FormLabel, FormSelect, Option } from "lqx-react/lib";
import * as React from "react";
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { Can } from "src/app/services/can";
import { GenericExternalSystemType } from "../../api/assetEvent";
import { AssetType } from "../../api/assetType";
import { DestinationTarget } from "../../api/connectionSettings";
import { getFacilities } from "../../api/facilities";
import { PlatformsLookup, ProductsLookup } from "../../api/lookups";
import { getPrograms } from "../../api/programs";
import { DigiCheckbox } from "../../shared";
import { MultiSelectDropdown } from "./multiselect-dropdown";

export const DestinationTargetCard = (
    { destinationTargetCard,
        products,
        platforms,
        fileCode }:
        {
            destinationTargetCard: DestinationTarget,
            products: ProductsLookup,
            platforms: PlatformsLookup,
            fileCode: string,
        }) => {

    const [filteredProductItems, setFilteredProductItems] = React.useState<any>([]);

    const getFacilityItems = React.useCallback(async (searchText) => {
        return (await getFacilities(searchText));
    }, []);

    const getProgramItems = React.useCallback(async (searchText) => {
        return (await getPrograms(searchText));
    }, []);

    React.useEffect(() => {
        setFilteredProductItems(products.getFilteredItems(destinationTargetCard.$.assetTypeId.value));
    }, [destinationTargetCard.$.assetTypeId]);

    return destinationTargetCard ? (<div style={{ marginLeft: '10px' }}>
        {
            <Flex row>
                <Column>
                    <StyledFormLabel>Asset Type</StyledFormLabel>
                    <FormSelect disabled $value={destinationTargetCard.$.assetTypeId}>
                        <Option value={AssetType.invoice}>Invoice</Option>
                        <Option value={AssetType.creditNote}>Credit Note</Option>
                        <Option value={AssetType.payment}>Payment</Option>
                        <Option value={AssetType.remittanceAdvice}>Remittance Advice</Option>
                        <Option value={AssetType.unappliedCash}>Unapplied Cash</Option>
                        <Option value={AssetType.customerReferenceData}>Customer Reference Data</Option>
                    </FormSelect>
                </Column>
                <Column>
                    <StyledFormLabel>Platform</StyledFormLabel>
                    <FormSelect disabled={!fileCode} $value={destinationTargetCard.$.platform}>
                        {platforms.items.map((sm) => (<Option key={sm.id} value={sm.id}>{sm.name}</Option>))}
                    </FormSelect>
                </Column>
                <Column>
                    <StyledFormLabel>Module</StyledFormLabel>
                    <FormSelect disabled={filteredProductItems.length === 0} $value={destinationTargetCard.$.product}>
                        {filteredProductItems.map((sm) => (<Option key={sm.id} value={sm.name}>{sm.description}</Option>))}
                    </FormSelect>
                </Column>
                {Can(UserEntitlementCatalogs.ManageTargetFacility) &&
                    destinationTargetCard.product.toLowerCase() === GenericExternalSystemType[GenericExternalSystemType.scf] &&
                        <Column style={{ flex: "2" }}>
                            <StyledFormLabel>Facilities</StyledFormLabel>
                            <MultiSelectDropdown
                                isMultiple={true}
                                getItems={getFacilityItems}
                                selectedItems={destinationTargetCard.facilities}
                                handleChange={(facilities) => destinationTargetCard.facilities = facilities}
                            />
                        </Column>
                }
                {Can(UserEntitlementCatalogs.ManageTargetProgram) && 
                    destinationTargetCard.product.toLowerCase() === GenericExternalSystemType[GenericExternalSystemType.abf] &&
                    <Column style={{ flex: "2" }}>
                        <StyledFormLabel>Program</StyledFormLabel>
                        <MultiSelectDropdown
                            getItems={getProgramItems}
                            selectedItems={destinationTargetCard.program}
                            handleChange={(program) => destinationTargetCard.program = program}
                        />
                    </Column>
                }
                <Column style={{ flex: "1.5" }}>
                    <CheckboxSection>
                        <DigiCheckbox label={`Automatically Digitize/Modify Assets`} $checked={destinationTargetCard.$.isEnabled} />
                    </CheckboxSection>
                </Column>
            </Flex>
        }
    </div>) : <></>;
}

const StyledFormLabel = styled(FormLabel)({
    alignSelf: 'inherit',
    paddingLeft: 4
})

const CheckboxSection = div({
    paddingTop: '20px',
    '& span': {
        color: '#767D84',
        fontSize: '12px',
        alignSelf: 'center',
        fontFamily: 'Montserrat',
        fontWeight: 500
    }
});
